import Vue from 'vue';
import app from 'app';
import moment from 'moment';

Vue.filter('culture', (str) => app.culture.get(str));

Vue.filter('fileSizeString', function (number) {
  return Number(number).toSizeString();
});

Vue.filter('timeFormat', function (milliseconds, format) {
  return moment(milliseconds).format(format);
});

Vue.filter('timeFormatDuration', function (milliseconds, format) {
  return moment.utc(milliseconds).format(format);
});

Vue.filter('printDateTime2', function (dateLong) {
  return dateLong
    ? moment(dateLong).format('MMM D, YYYY, h:mm a')
    : 'Date not available';
});
